/** @format */

import { actionTypes } from './actions'
import { actionTypes as signUserTypes } from '../auth/actions'

const initialState = {
  displayName: '',
  name: '',
  surName: '',
  age: '',
  country: '',
  city: '',
  phoneNumber: '',
  photoURL: '',
  email: '',
  emailVerified: undefined,
}

export const profileReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case signUserTypes.SIGN_IN_SUCCESS:
    case signUserTypes.SIGN_UP_SUCCESS:
      return {
        ...state,
        email: payload.email,
        emailVerified: payload.emailVerified,
        photoURL: payload.photoURL,
        displayName: payload.displayName,
        phoneNumber: payload.phoneNumber,
      }
    case actionTypes.GET_PROFILE_SUCCESS:
      return { ...state }
    default:
      return state
  }
}
